// extracted by mini-css-extract-plugin
export default {"filterText":"lSoI_DgC"};